import React from 'react';
import { Panel } from 'react-bootstrap';

const LeadInvoiceActionPanel = ({ body, title }) => (
  <Panel>
    <Panel.Heading>
      <Panel.Title componentClass="h3">{title}</Panel.Title>
    </Panel.Heading>
    <Panel.Body>{body}</Panel.Body>
  </Panel>
);

export default LeadInvoiceActionPanel;
